/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { serializeAccountCyclePutRequest, type AccountCyclePutRequest } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/cycle
 */
export interface CycleRequestBuilder extends BaseRequestBuilder<CycleRequestBuilder> {
    /**
     * Removes the cycle properties of an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Progresses an account to its next cycle
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DateOnly>}
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DateOnly | undefined>;
    /**
     * Sets the cycle properties of an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     put(body: AccountCyclePutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Removes the cycle properties of an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Progresses an account to its next cycle
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Sets the cycle properties of an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: AccountCyclePutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CycleRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/cycle";
/**
 * Metadata for all the requests in the request builder.
 */
export const CycleRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: CycleRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
    post: {
        uriTemplate: CycleRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "DateOnly",
    },
    put: {
        uriTemplate: CycleRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAccountCyclePutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
